import { useState } from "react";
import { useSelector } from "react-redux";
import PropertyMediaQueueGrid from "./shared/PropertyMediaQueueGrid";
import PropertyMediaSavedGrid from "./shared/PropertyMediaSavedGrid";
import PropertyMediaUploadPanel from "./shared/PropertyMediaUploadPanel";
import { usePropertyMediaManager } from "./shared/usePropertyMediaManager";
import { toAbsoluteMediaUrl } from "./shared/propertyMediaHelpers";

const MEDIA_TYPE = "PHOTO_STEP7";

export default function StepPhotoGallery({ propertyId, property, onSave }) {
  const userId = useSelector((state) => state.auth?.user?.id);
  const [refreshing, setRefreshing] = useState(false);

  const {
    deletingId,
    onDeleteMedia,
    onFileInputChange,
    pasteBoxRef,
    queue,
    removeFromQueue,
    savedMedia,
    updateQueueLabel,
    uploadError,
    uploadQueue,
    uploading,
  } = usePropertyMediaManager({
    property,
    propertyId,
    onSave,
    mediaType: MEDIA_TYPE,
    listMediaType: null,
    labelBase: "gallery",
    defaultClipboardBase: "gallery",
    userId,
  });

  async function refreshGallery() {
    if (!onSave) return;
    setRefreshing(true);
    try {
      const result = onSave();
      if (result && typeof result.then === "function") {
        await result;
      }
    } finally {
      setRefreshing(false);
    }
  }

  return (
    <div className="p-4 space-y-4">
      <div className="space-y-2">
        <div className="text-sm font-semibold text-gray-900 dark:text-white">
          Galeria de fotos
        </div>
        <p className="text-xs text-gray-500">
          Organize, visualize e complemente as fotos da propriedade em um só lugar
          para manter o registro visual atualizado.
        </p>
      </div>

      <PropertyMediaUploadPanel
        helperText="Cole (Ctrl+V) ou selecione arquivos para documentar a propriedade."
        onFileInputChange={onFileInputChange}
        onUpload={uploadQueue}
        pasteBoxRef={pasteBoxRef}
        queueLength={queue.length}
        saveButtonLabel="Atualizar galeria"
        saving={refreshing}
        title="Enviar novas fotos"
        uploadError={uploadError}
        uploading={uploading}
        onSave={refreshGallery}
      >
        <div className="text-xs text-gray-500">
          Cada imagem pode receber legenda e será marcada como foto oficial da
          propriedade.
        </div>
      </PropertyMediaUploadPanel>

      <PropertyMediaQueueGrid
        items={queue}
        labelPlaceholder="Ex: fachada lateral"
        onChangeLabel={updateQueueLabel}
        onRemove={removeFromQueue}
      />

      {savedMedia.length ? (
        <PropertyMediaSavedGrid
          deletingId={deletingId}
          items={savedMedia}
          onDelete={onDeleteMedia}
          sectionTitle="Fotos já adicionadas"
          typeLabel="galeria"
          emptyLabel="sem legenda"
          imageHeightClass="h-56"
          viewButtonLabel="Abrir"
          onView={(item) =>
            window.open(
              toAbsoluteMediaUrl(item.url),
              "_blank",
              "noopener,noreferrer",
            )
          }
        />
      ) : (
        <div className="text-sm text-gray-500">
          Nenhuma foto cadastrada ainda – use o painel acima para adicionar.
        </div>
      )}
    </div>
  );
}
